/*
 * @Author: liupan
 * @Date: 2023-12-21 16:00:43
 * @LastEditors: liupan
 * @LastEditTime: 2023-12-25 11:13:01
 * @Description: TODO
 */
import Stars from 'comps/Stars';
export default function ScoreCard({ score }) {
  return (
    <>
      <div className="score-card">
        <span className="score-title">店铺评分</span>
        <div className="vue-star-score medium">
          <Stars score={score} custom={{ starSize: 20, starGap: 8 }} isPercent />
        </div>
      </div>
      <style>
        {`
          .score-card .score-title {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-right: 37px;
          }
          .score-card {
          padding: 25px 63px;
          background-image: linear-gradient(
            270deg,
            rgba(250, 84, 1, 0) 0%,
            rgba(250, 84, 1, 0.08) 100%
          );
          display: flex;
          align-items: center;
          }
        `}
      </style>
    </>
  );
}
